/**
 * How the person last interacted with the page, written to `<html data-input="pointer|keyboard">`. Containers
 * that take focus so keyboard users can land in them or scroll them (tab panels, the map's detail panel, the
 * page itself) then show no focus ring after a click or tap, while keyboard focus keeps its ring. Browsers
 * differ in when they let a clicked or script-focused container match :focus-visible; this makes it one rule.
 */
export function trackInputModality(root: HTMLElement = document.documentElement) {
  const set = (mode: 'pointer' | 'keyboard') => {
    if (root.dataset.input !== mode) root.dataset.input = mode;
  };
  const onPointer = () => set('pointer');
  // shortcuts with a modifier (copy, zoom) are not keyboard navigation
  const onKey = (e: KeyboardEvent) => {
    if (!e.ctrlKey && !e.metaKey && !e.altKey) set('keyboard');
  };
  window.addEventListener('pointerdown', onPointer, { capture: true, passive: true });
  window.addEventListener('keydown', onKey, { capture: true });
  return () => {
    window.removeEventListener('pointerdown', onPointer, { capture: true });
    window.removeEventListener('keydown', onKey, { capture: true });
  };
}
